import React, { lazy, Suspense } from 'react'
import { AppLoader } from '@src/components/AppLoader/AppLoader'
import { BonusAppMicroProps } from 'bonus-page/BonusAppMicro'
import { getAuthToken } from '@src/stores/auth/user/functions'
import { ErrorContainer, ResponsiveContainer } from './Bonus.styled'

const BonusAppMicroFallback = () => (
  <ErrorContainer>
    Failed to load Bonus App. Please try again later.
  </ErrorContainer>
);
const BonusAppMicro = lazy<React.ComponentType<BonusAppMicroProps>>(() => {
  return new Promise((resolve) => {
    setTimeout(() => {
      import('bonus-page/BonusAppMicro')
        .then((module) => {
          console.log('Successfully loaded BonusAppMicro:', module);
          resolve(module);
        })
        .catch((error) => {
          console.error('Error loading BonusAppMicro micro frontend:', error);
          resolve({ default: BonusAppMicroFallback as unknown as React.ComponentType<BonusAppMicroProps> });
        });
    }, 100);
  });
});

const BonusPage: React.FC = () => {
  const sessionToken = getAuthToken();
  return (
      <ResponsiveContainer>
        <div id="bonus-app-root">
          <Suspense fallback={<AppLoader />}>
            <BonusAppMicro session={sessionToken} />
          </Suspense>
        </div>
      </ResponsiveContainer>
  )
}
export default BonusPage
